/**
 * @description FormItem
 * @param {String} title  标题 默认值''
 * @param {Node} topLeftNode 右上角内容 默认值 null
 * @param {String} errorTxt  错误信息 默认 ''
 * @param {String} tip  提示信息 默认 ''
 * @param {Boolean} isShowTopBox  是否显示顶部框 默认 true
 * @param {String} customClassName   className
 */
import React, {memo} from "react";
const FormItem = memo((props) => {
  const { title, topLeftNode, tip, errorTxt, isShowTopBox,customClassName='' } = props;
  return (
    <div className={`aia-bx-form-group ${customClassName}`}>
      {
        isShowTopBox && <div className="aia-bx-form-group-top aia-bx-flex justify-between">
        {title && <span className="aia-bx-default-body-M">{title}</span>}
        {topLeftNode}
      </div>
      }
      {props.children}
      <div className="aia-bx-form-group-info">
        {errorTxt && <p className="aia-bx-form-error">{errorTxt}</p>}
        {!errorTxt&&tip && <p className="aia-bx-form-info aia-bx-default-body-S">{tip}</p>}
      </div>
    </div>
  );
});
FormItem.defaultProps = {
  isShowTopBox: true
};

export default FormItem;
